import { SITE_NAME, DEFAULT_OG_IMAGE, baseMetadata } from "lib/seoConfig";

import app from "./app";
import { getEnvValue, getExternalAssetFilePath } from "./utils";

const defaultImageUrl = DEFAULT_OG_IMAGE;

const meta = Object.freeze({
  promoteBlockscoutInTitle:
    getEnvValue("NEXT_PUBLIC_PROMOTE_BLOCKSCOUT_IN_TITLE") === "false"
      ? false
      : true,
  siteName: SITE_NAME,
  title: baseMetadata.title as string,
  description: baseMetadata.description as string,
  keywords: baseMetadata.keywords as string,
  og: {
    description:
      getEnvValue("NEXT_PUBLIC_OG_DESCRIPTION") ||
      baseMetadata.description ||
      "",
    imageUrl:
      getExternalAssetFilePath("NEXT_PUBLIC_OG_IMAGE_URL") ||
      DEFAULT_OG_IMAGE ||
      app.baseUrl + defaultImageUrl,
    enhancedDataEnabled:
      getEnvValue("NEXT_PUBLIC_OG_ENHANCED_DATA_ENABLED") === "true",
  },
  seo: {
    enhancedDataEnabled:
      getEnvValue("NEXT_PUBLIC_SEO_ENHANCED_DATA_ENABLED") === "true",
  },
  twitter: {
    site: "@MorphNetwork",
    creator: "@MorphNetwork",
  },
});

export default meta;
